// components/BottomButton.tsx
import React from "react";
import clsx from "clsx";
import { FormattedMessage } from "react-intl";
import { Spinner } from "components";
import { IThirdPartyService, INTEGRATED_SERVICE } from "request";

interface BottomButtonProps {
  connectService: IThirdPartyService | undefined;
  isAuthLoading: boolean;
  isAuthorized: boolean;
  isLoading: boolean;
  onConnect: () => void;
  publicPath?: string;
}

export const BottomButton: React.FC<BottomButtonProps> = ({
  connectService,
  isAuthLoading,
  isAuthorized,
  isLoading,
  onConnect,
  publicPath,
}) => {
  const renderConnectButton = () => {
    if (connectService?.showFlag === INTEGRATED_SERVICE.googleFit) {
      return (
        <div
          className="w-fit px-4 bg-white flex items-center justify-center mx-auto p-2 rounded-[10px] font-bold shadow-[0_2px_2px_#ccc] active:bg-[#4285f4] active:text-white visited:bg-white visited:text-black visited:opacity-[0.54]"
          onClick={onConnect}
        >
          <img
            src={`${publicPath}/icons/g-logo.png`}
            alt="Google"
            className="w-[27px] h-[27px] mr-[10px]"
          />
          <span className="opacity-[0.54] text-lg">
            <FormattedMessage id="thirdParty.connect.button.googleSignIn" />
          </span>
        </div>
      );
    }

    return (
      <button
        type="button"
        onClick={onConnect}
        className={clsx(
          "w-full flex items-center justify-center text-[#F7F7F9] rounded-lg h-[54px] text-lg",
          {
            "bg-primary opacity-70": isAuthLoading,
            "bg-error": !isAuthLoading && isAuthorized,
            "bg-primary": !isAuthLoading && !isAuthorized,
          }
        )}
      >
        {isAuthLoading ? (
          <Spinner extraSmall className="border-white" />
        ) : (
          <FormattedMessage
            id={`thirdParty.connect.button.${
              isAuthorized ? "unlink" : "content"
            }`}
          />
        )}
      </button>
    );
  };

  return (
    <div className="fixed bottom-0 left-0 w-full py-4 p-4 bg-page dark:bg-gray323434">
      { !isLoading && renderConnectButton()}
    </div>
  );
};
